import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import NProgress from 'nprogress'
import { getUserToken } from '@/api/common/auth'
import 'nprogress/nprogress.css'
import { urlSetting } from '@/configs/api'
import { submitWaiting } from '@/configs/functions'
import Router from '@/router'

const instance = axios.create({
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 3000,
  responseType: 'json'
})
const clickWaiting = (show: boolean) => {
  if (show) {
    NProgress.start()
  }
  else {
    NProgress.done()
  }
  submitWaiting(show)
}
export const setAxiosIntercepters = () => {
  // Add a response interceptor
  instance.interceptors.response.use((response: AxiosResponse<any>) => {
    clickWaiting(false)
    return response
  }, (error: any) => {
    if (error.response) {
      if (error.response.status === 401) {
        Router.push('/login')
      } else if (error.response.status === 403) {
        console.log(error.response)
        Router.push('/404')
      }
    }
    console.log(error)
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      console.log('Error', error.message)
    }
    clickWaiting(false)
    return Promise.reject(error)
  })
  //请求拦截器，访问域名校验 Add a request interceptor
  instance.interceptors.request.use((config: AxiosRequestConfig) => {
    if (config.url && config.url.indexOf(urlSetting.domain) === 0) {
      const { token, valid } = getUserToken()
      if (token && valid) {
        config.headers = config.headers || {}
        config.headers['Authorization'] = `Bearer ${token}`
      }
    }
    config.headers['Access-Control-Allow-Origin'] = '*'
    // h_np: hide nprogress
    if (config.url && config.url.indexOf('h_np') === -1) {
      clickWaiting(true)
    }
    return config
  }, (error: any) => {
    console.log('error', error)
    // Do something with request error
    clickWaiting(false)
    return Promise.reject(error)
  });
}

export default instance
